import { render, staticRenderFns } from "./supplier-detail-basic-info.vue?vue&type=template&id=d0b0d75e&scoped=true&"
import script from "./supplier-detail-basic-info.vue?vue&type=script&lang=js&"
export * from "./supplier-detail-basic-info.vue?vue&type=script&lang=js&"
import style0 from "./supplier-detail-basic-info.vue?vue&type=style&index=0&id=d0b0d75e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b0d75e",
  null
  
)

export default component.exports